import React from "react";
import {
  Container,
  Row,
  Column,
  FooterLink
} from "./FooterStyles";

const Footer = () => {
  return (

      <Container>
        <Row>
          <Column>
            <FooterLink href="/termsOfService">Terms of Service</FooterLink>
          </Column>
          <Column>
            <FooterLink href="/privacyPolicy">Privacy Policy</FooterLink>
          </Column>
        </Row>
      </Container>
  );
};
export default Footer;